var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"password-page"},[_c('h2',[_vm._v(_vm._s(_vm.$t('修改密码')))]),_c('el-button',{attrs:{"type":"primary","icon":"el-icon-lock"},on:{"click":function($event){_vm.visible = true}}},[_vm._v(_vm._s(_vm.$t('修改密码')))]),_c('password',{attrs:{"visible":_vm.visible},on:{"close":function($event){_vm.visible = false}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }